import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

import { Dealership } from '../../lib/types/Dealership'
import { useGetDealershipById } from '../../api/admin/useGetDealershipById'
import { User } from '../../lib/types/User'
import { useSelector } from 'react-redux'
import { currentUserSelector } from '../selectors/userSelector'

type PersistedDealershipStore = {
  dealership: Dealership | null
  setPersistedDealership: (dealership: Dealership) => void
}

type DealershipStore = {
  dealership: Dealership | null
  setDealership: (dealership: Dealership) => void
}

export const usePersistedDealershipStore = create<PersistedDealershipStore>()(
  persist(
    (set, get) => ({
      dealership: null,
      setPersistedDealership: (dealership: Dealership) => set({ dealership }),
    }),
    {
      name: 'dealership',
    },
  ),
)

export const useDealershipStore = create<DealershipStore>()(
  persist(
    (set, get) => ({
      dealership: null,
      setDealership: (dealership: Dealership) => {
        set({ dealership })
        const { setPersistedDealership } = usePersistedDealershipStore.getState()
        setPersistedDealership(dealership)
      },
    }),
    {
      name: 'dealership',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)

export const useDealership = (): Dealership | null => {
  const dealership = useDealershipStore((state) => state.dealership)
  const user: User | null = useSelector(currentUserSelector)
  const { organizations = [] } = user || { organizations: [] }

  return (
    organizations
      .flatMap((org) => org.dealerships)
      .find(
        (d) =>
          d?.id === dealership?.id && d?.organization_id === dealership?.organization_id,
      ) || null
  )
}
